import type { ISwSettings } from "app/@types/ISwSettings";

import { isNtFlowNew } from "./isNtFlowNew";
import { PaymentPeriod } from "./paymentPeriod";

export const resolveDefaultPaymentPeriod = (
    swSettings: ISwSettings,
    isPaymentPeriodTestOn: boolean,
): PaymentPeriod => {
    const isNewNtFlow = isNtFlowNew(swSettings);

    return isPaymentPeriodTestOn && !isNewNtFlow ? PaymentPeriod.ANNUAL : PaymentPeriod.MONTHLY;
};
